var map = {
	"./01_Isabelle Ihl Architektur_Bildbauten.jpg": 934,
	"./02_Isabelle Ihl Architektur_Bildbauten.jpg": 7242,
	"./03_Isabelle Ihl Architektur_Bildbauten.jpg": 647,
	"./04_Isabelle Ihl Architektur_Bildbauten.jpg": 7859,
	"assets/c4_picturebuilding/01_Isabelle Ihl Architektur_Bildbauten.jpg": 934,
	"assets/c4_picturebuilding/02_Isabelle Ihl Architektur_Bildbauten.jpg": 7242,
	"assets/c4_picturebuilding/03_Isabelle Ihl Architektur_Bildbauten.jpg": 647,
	"assets/c4_picturebuilding/04_Isabelle Ihl Architektur_Bildbauten.jpg": 7859
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2741;